var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-update-parameters animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _vm.$store.getters.roleID === "4"
              ? _c("b-card", [
                  _c("h1", { staticClass: "lbv-page-title updateParameters" }, [
                    _vm._v(
                      "\n          Matlab Parameters Dictionary\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "updateParametersInputs" }, [
                    _c(
                      "div",
                      {
                        staticClass: "section",
                        staticStyle: {
                          "margin-top": "20px",
                          "min-height": "100px",
                        },
                      },
                      [
                        _c(
                          "b-row",
                          { staticClass: "header" },
                          [
                            _c(
                              "b-col",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  "margin-top": "10px",
                                },
                                attrs: { cols: "12" },
                              },
                              [
                                _c("h3", { staticClass: "form-label" }, [
                                  _vm._v(
                                    "\n                  Description\n                "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "This page is provided so that you can create and update definitions of parameters that are going to added to device for leak calculation. "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n              - Click on any parameter from table below to edit parameter\n              "
                          ),
                          _c("br"),
                          _vm._v(
                            "- Use filter to find your parameter (start typing in the field)\n              "
                          ),
                          _c("br"),
                          _vm._v(
                            '- Order parameters by clicking "Parameter Name" header\n              '
                          ),
                          _c("br"),
                          _vm._v(
                            "- When array type of parameter chosen just pass parameters separated by comma e.g. 2, 3.5, 21 (no need to add brackets e.g. [2, 3.5, 21])\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.updateParam.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "section",
                            staticStyle: {
                              "margin-top": "20px",
                              "min-height": "100px",
                            },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "header" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      "margin-top": "10px",
                                    },
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c("h3", { staticClass: "form-label" }, [
                                      _vm._v(
                                        "\n                    Description\n                  "
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "push-down" },
                              [
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Parameter Name:"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "6" } }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.parameterName,
                                        expression: "parameterName",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.parameterName },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.parameterName =
                                            $event.target.value
                                        },
                                        _vm.parameterNameChange,
                                      ],
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("label", [_vm._v("Parameter type")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "2" } },
                                  [
                                    _c(
                                      "b-form-select",
                                      {
                                        staticClass: "full-width",
                                        on: { input: _vm.changeParameterType },
                                        model: {
                                          value: _vm.parameterType,
                                          callback: function ($$v) {
                                            _vm.parameterType = $$v
                                          },
                                          expression: "parameterType",
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          { attrs: { value: "number" } },
                                          [
                                            _vm._v(
                                              "\n                      Number\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "array" } },
                                          [
                                            _vm._v(
                                              "\n                      Array\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "push-down" },
                              [
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.minValLabel)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.parameterMinValue,
                                        expression: "parameterMinValue",
                                      },
                                    ],
                                    staticClass: "form-control full-width",
                                    attrs: { id: "minValue", type: "text" },
                                    domProps: { value: _vm.parameterMinValue },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.parameterMinValue =
                                            $event.target.value
                                        },
                                        _vm.clearError,
                                      ],
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.maxValLabel)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.parameterMaxValue,
                                        expression: "parameterMaxValue",
                                      },
                                    ],
                                    staticClass: "form-control full-width",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.parameterMaxValue },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.parameterMaxValue =
                                            $event.target.value
                                        },
                                        _vm.clearError,
                                      ],
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.defValLabel)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.parameterDefaultValue,
                                        expression: "parameterDefaultValue",
                                      },
                                    ],
                                    staticClass: "form-control full-width",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.parameterDefaultValue,
                                    },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.parameterDefaultValue =
                                            $event.target.value
                                        },
                                        _vm.clearError,
                                      ],
                                    },
                                  }),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "push-down" },
                              [
                                _c("b-col", { attrs: { cols: "8" } }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary parameterUpdate",
                                      attrs: { type: "submit" },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.buttonLabel)),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("label", [
                                    _vm._v("Filter by parameter name:"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "2" } }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.filterParameterName,
                                        expression: "filterParameterName",
                                      },
                                    ],
                                    staticClass: "form-control full-width",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.filterParameterName,
                                    },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.filterParameterName =
                                            $event.target.value
                                        },
                                        _vm.filterName,
                                      ],
                                    },
                                  }),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "section",
                            staticStyle: { "margin-top": "20px" },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "header" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      "margin-top": "10px",
                                    },
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c("h3", { staticClass: "form-label" }, [
                                      _vm._v(
                                        "\n                    List of parameters\n                  "
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-table", {
                              attrs: {
                                responsive: "",
                                striped: "",
                                hover: "",
                                items: _vm.parameterList,
                                fields: _vm.fields,
                              },
                              on: { "row-clicked": _vm.myRowClickHandler },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }